import {Component,OnInit} from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {Principal} from 'src/app/core/auth/principal.service';
import {RoleUtil} from './../../shared/util/role-util';

@Component({
    selector: 'jhi-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

    RoleUtil =RoleUtil;
    currentYear: number = new Date().getFullYear();
    constructor(
        private activatedRoute: ActivatedRoute,
        public router: Router,
        public principal: Principal,

    ) {
    }
    ngOnInit(): void {

    }
}
